import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from '@core/services/loader.service';
import { Loader } from '@shared/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Loader, TranslateModule],
  templateUrl: './app.html',
})
export class App {
  protected readonly loader = inject(LoaderService);
}
